import { ALGOLIA_ROOT_LEVEL_QUERY_PARAMETERS } from '../../../constants/algolia';

export function isSearchQueryParameter(parameter: string): boolean {
  return ALGOLIA_ROOT_LEVEL_QUERY_PARAMETERS.some(algoliaFilter => parameter.includes(algoliaFilter));
}
